import { RouterState } from 'connected-react-router';
import { Location } from 'history';

import autoReducers from 'store/autoReducers';
import { ReducerFunction } from 'store/createReducer';
import accounts from 'store/models/accounts';
import accountStatistics from 'store/models/accountStatistics';
import acts from 'store/models/acts';
import actsSummary from 'store/models/actsSummary';
import adfoxInfo from 'store/models/adfoxInfo';
import adminBannerAction from 'store/models/adminBannerAction';
import adminCampaignAction from 'store/models/adminCampaignAction';
import aiImageGeneration from 'store/models/aiImageGeneration';
import auctionData from 'store/models/auctionData';
import balance from 'store/models/balance';
import banners from 'store/models/banners';
import bannerTextGeneration from 'store/models/bannerTextGeneration';
import billingFunnel from 'store/models/billingFunnel';
import campaignCreationWizard from 'store/models/campaignCreationWizard';
import campaignsDashboard from 'store/models/campaignsDashboard';
import campaignsFilters from 'store/models/campaignsFilters';
import campaignsReport from 'store/models/campaignsReport';
import campaignStatistic from 'store/models/campaignStatistic';
import changeHistory from 'store/models/changeHistory';
import clickme from 'store/models/clickme';
import createBanner from 'store/models/createBanner';
import createCampaign from 'store/models/createCampaign';
import createQuickCampaign from 'store/models/createQuickCampaign';
import crmActivity from 'store/models/crmActivity';
import dashboard from 'store/models/dashboard';
import efficiency from 'store/models/efficiency';
import experiments from 'store/models/experiments';
import gallery from 'store/models/gallery';
import gift from 'store/models/gift';
import incomeExpense from 'store/models/incomeExpense';
import invoiceDetail from 'store/models/invoiceDetail';
import invoices from 'store/models/invoices';
import mainMenu from 'store/models/mainMenu';
import manualCharges from 'store/models/manualCharges';
import moderation from 'store/models/moderation';
import multiCreation from 'store/models/multiCreation';
import notification from 'store/models/notification';
import overflow from 'store/models/overflow';
import payerCreate from 'store/models/payerCreate';
import payerDetail from 'store/models/payerDetail';
import payers from 'store/models/payers';
import predictWindow from 'store/models/predictWindow';
import promoCodes from 'store/models/promoCodes';
import quiz from 'store/models/quiz';
import remainderBudgets from 'store/models/remainderBudgets';
import requisites from 'store/models/requisites';
import settings from 'store/models/settings';
import sourceAccounts from 'store/models/sourceAccounts';
import statistics from 'store/models/statistics';
import stoppedCampaigns from 'store/models/stoppedCampaigns';
import translations from 'store/models/translations';
import user from 'store/models/user';
import userDetail from 'store/models/userDetail';
import users from 'store/models/users';
// exp_PORTFOLIO-61587_next_line
import vacancyOfTheDay from 'store/models/vacancyOfTheDay';
import videoGallery from 'store/models/videoGallery';
// exp_PORTFOLIO-58018_next_line
import vrCampaign from 'store/models/vrCampaign';

const reducers = {
    ...autoReducers,
    accounts,
    accountStatistics,
    acts,
    actsSummary,
    adfoxInfo,
    adminBannerAction,
    adminCampaignAction,
    aiImageGeneration,
    auctionData,
    balance,
    banners,
    bannerTextGeneration,
    billingFunnel,
    campaignCreationWizard,
    campaignsDashboard,
    campaignsFilters,
    campaignsReport,
    campaignStatistic,
    changeHistory,
    clickme,
    createBanner,
    createCampaign,
    createQuickCampaign,
    crmActivity,
    dashboard,
    efficiency,
    experiments,
    gallery,
    gift,
    incomeExpense,
    invoiceDetail,
    invoices,
    mainMenu,
    manualCharges,
    moderation,
    multiCreation,
    notification,
    overflow,
    payers,
    payerCreate,
    payerDetail,
    predictWindow,
    promoCodes,
    quiz,
    remainderBudgets,
    requisites,
    settings,
    sourceAccounts,
    statistics,
    stoppedCampaigns,
    translations,
    user,
    userDetail,
    users,
    // exp_PORTFOLIO-61587_next_line
    vacancyOfTheDay,
    videoGallery,
    // exp_PORTFOLIO-58018_next_line
    vrCampaign,
};

export type Store<R = typeof reducers> = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [K in keyof R]: R[K] extends ReducerFunction<infer D, any> ? D : never;
};

interface AugmentedLocation extends Location {
    query: Record<string, string>;
}

interface RouteStateWithLocation extends RouterState {
    location: AugmentedLocation;
}

declare module 'react-redux' {
    export interface DefaultRootState extends Store {
        router: RouteStateWithLocation;
    }
}

export default reducers;
